import { BaseAPI } from '../base/service';
import { CourseType } from '../enums';
import { Chapter, RateModel, Topic } from './dto';

export class ChapterAPI extends BaseAPI {
  private year = new Date().getFullYear();
  public getChapters(type: CourseType): Promise<Chapter[]> {
    return this.api.get(`${type}/${this.year}/playlist/`);
  }

  public getChapter(id: number, type: CourseType): Promise<Chapter> {
    return this.api.get(`${type}/${this.year}/playlist/${id}/`);
  }

  public getTopics(type: CourseType): Promise<Topic[]> {
    return this.api.get<any, Topic[]>(`${type}/${this.year}/topic/?option=shortened/`);
  }

  public postRate(rate: RateModel, type: CourseType): Promise<any> {
    return this.api.post(`${type}/${this.year}/playlist-evaluation/`, rate);
  }

  public putRate(rate: RateModel, type: CourseType): Promise<any> {
    return this.api.put(`${type}/${this.year}/playlist-evaluation/`, rate);
  }
}
